export const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 3000, min: 1100 },
    items: 4,
    slidesToSlide: 2,
    paritialVisibilityGutter: 10,
  },
  desktop: {
    breakpoint: { max: 1100, min: 768 },
    items: 3,
    paritialVisibilityGutter: 30,
    slidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 768, min: 0 },
    items: 2,
    slidesToSlide: 1,
    paritialVisibilityGutter: 20,
  },
  mobile: {
    breakpoint: { max: 500, min: 0 },
    items: 1,
    slidesToSlide: 1,
    paritialVisibilityGutter: 100,
  },
};

export const TREASORY = 'treasory';
export const PUBLIC_PRIVETES = 'publicPrivates';
export const BUSINESS_WOMAN = 'businessWoman';
export const IMPORT_EXPORT = 'importExport';

export const variants = {
  hidden: { opacity: 0, y: 200 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      damping: 50,
    },
  },
};
